/* Revisione cliente: alla fine di ogni sezione dell'articolo ci va un bottone
   con lo stesso link dell'immagine di quella sezione. Si fa qui e non a mano nel
   testo perche' cosi vale per tutti gli articoli, anche quelli migrati dal vecchio
   sito e quelli che il cliente scrivera' domani, senza dover ricordarsi niente.

   Regola: una sezione = da un <h2> al successivo. Il bottone compare solo se in
   quella sezione c'e' UN solo indirizzo linkato sulle immagini: con due o piu
   link diversi (le guide regalo, gli oroscopi) un bottone solo sarebbe una scelta
   arbitraria, quindi si lascia stare. */

if (typeof customElements.get('article-section-cta') == 'undefined') {

	class ArticleSectionCta extends HTMLElement {

		connectedCallback() {
			this.etichetta = this.dataset.label || '';
			this.classi = this.dataset.buttonClass || 'kt-button kt-button--outline kt-button--small';
			if (!this.etichetta) return;
			// Il corpo dell'articolo e' fuori da questo elemento: si aspetta che sia nel DOM.
			if (document.readyState === 'loading') {
				document.addEventListener('DOMContentLoaded', () => this.inserisci(), { once: true });
			} else {
				this.inserisci();
			}
		}

		inserisci() {
			const corpo = document.querySelector('.kt-article-content');
			if (!corpo || corpo.dataset.ctaFatti) return;
			corpo.dataset.ctaFatti = '1';

			this.sezioni(corpo).forEach(sezione => {
				const indirizzi = [...new Set(
					sezione
						.flatMap(elm => [...elm.querySelectorAll('img')])
						.map(img => img.closest('a'))
						.filter(a => a && a.getAttribute('href'))
						.map(a => a.getAttribute('href'))
				)];
				if (indirizzi.length !== 1) return;

				const ultimo = sezione[sezione.length - 1];
				// Se il cliente ha gia messo un bottone a mano non se ne aggiunge un secondo.
				if (ultimo.querySelector && ultimo.querySelector('.kt-button')) return;

				const riga = document.createElement('p');
				riga.className = 'kt-article-section-cta';
				const bottone = document.createElement('a');
				bottone.className = this.classi;
				bottone.href = indirizzi[0];
				bottone.textContent = this.etichetta;
				if (/^https?:\/\//i.test(indirizzi[0]) && !indirizzi[0].includes(window.location.host)) {
					bottone.target = '_blank';
					bottone.rel = 'noopener noreferrer';
				}
				riga.appendChild(bottone);
				ultimo.after(riga);
			});
		}

		sezioni(corpo) {
			const gruppi = [];
			let corrente = [];
			[...corpo.children].forEach(elm => {
				if (elm.tagName === 'H2' && corrente.length) { gruppi.push(corrente); corrente = []; }
				corrente.push(elm);
			});
			if (corrente.length) gruppi.push(corrente);
			return gruppi;
		}
	}

	customElements.define('article-section-cta', ArticleSectionCta);
}
